module.exports = __webpack_public_path__ + "img/Icon_Berechnen.dc09394f.svg";